export const AMAZON_TEST_PHONE = '9999999999';
export const AMAZON_TEST_CODE = '000000';

export function normalizePhone(phone) {
    return String(phone || '').replace(/\D/g, '').replace(/^1/, '');
}

export function isAmazonTestPhone(phone) {
    return normalizePhone(phone) === AMAZON_TEST_PHONE;
}
